import Servico from './Servico'

class ProfissionalBloqueioServico extends Servico {
  constructor() {
    super('bloqueio')
  }
}

export default ProfissionalBloqueioServico
